import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { Styles, Modes } from '@lib/form/date-range-picker';

@Component({
  selector: 'sn-analytics-widget-date',
  templateUrl: './analytics-widget-date.component.html',
  styleUrls: ['./analytics-widget-date.component.scss'],
})
export class AnalyticsWidgetDateComponent implements OnInit {
  public readonly form = new UntypedFormGroup({});
  public readonly formModel: any = {};
  public readonly formFields: SnFormFieldConfig[] = [
    {
      key: 'date-range',
      type: 'date-range-picker',
      templateOptions: {
        style: Styles.Dropdown,
        custom: true,
        appearance: 'none',
        required: true,
        startTimestampKey: 'event_timestamp__gte',
        endTimestampKey: 'event_timestamp__lte',
        ranges: [
          { value: '1', mode: Modes.Day, label: 'Last Day' },
          { value: '2', mode: Modes.Day, label: 'Last 2 Day' },
          { value: '1', mode: Modes.Week, label: 'Last Week' },
          { value: '2', mode: Modes.Week, label: 'Last 2 Weeks' },
          { value: '1', mode: Modes.Month, label: 'Last Month' },
        ],
        change: (field, value) => {
          this.formModel['event_timestamp__gte'] = value['event_timestamp__gte'];
          this.formModel['event_timestamp__lte'] = value['event_timestamp__lte'];
          delete this.formModel['date-range'];
        },
      },
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public layer: any,
    private readonly _matDialogRef: MatDialogRef<AnalyticsWidgetDateComponent>,
  ) {}

  public ngOnInit(): void {}

  public submit(): void {
    this._matDialogRef.close(this.formModel);
  }
}
